<template>
  <div class="h-100">
    <Loader v-if="isCreating" />
    <Instance
      v-else
      instance="shiftLog"
      instance-name="Shift Log"
      :delete="(d) => shiftDay.remove(d)"
      :get="(d) => shiftDay.get(d)"
      :on-add-action="addAction"
      :hide-delete="!isCommonAdmin"
      :hide-add="!isCommonAdmin && !isSuperUser"
      :columns="columns"
      :initFilter="filter"
      :shiftLogToogle="true"
    />
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

import Instance from '../../CRUD/instance';
import Loader from '../../common/loader';
import { AuthMixin, AuthStorageMixin } from '../../../../mixins';
import api from '../../../api';

export default {
  title: 'ShiftLog',
  components: { Instance, Loader },
  mixins: [AuthMixin, AuthStorageMixin],
  data() {
    return {
      shiftDay: api.shiftDay,
      filter: {
        page: 1,
        limit: 10,
        totalCount: 0,
        sortBy: 'date',
        sortOrder: 'desc',
        searchQuery: '',
        endDate: moment().format('YYYY-MM-DD'),
      },
      isCreating: false,
    };
  },
  methods: {
    addAction() {
      this.$router.push({ name: 'Add Shift Log' });
    },
    columns() {
      return [
        {
          field: 'check',
          key: '1',
          type: 'checkbox',
          title: '',
          width: 50,
          align: 'center',
        },
        {
          field: 'date',
          title: this.$translate('Date'),
          key: '3',
          sortBy: 'asc',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return moment.utc(row.date).format('DD.MM.YYYY');
          },
        },
        {
          field: 'team',
          title: this.$translate('Team'),
          key: '6',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return this.$translate(row.team ? row.team.name : '');
          },
        },
        {
          field: 'shift',
          title: this.$translate('Shift'),
          key: '5',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return this.$translate(row.shift);
          },
        },
        {
          field: 'operationalArea',
          title: this.$translate('Facility'),
          key: '4',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return <div>{this.$translate(row.operationalArea.name)}</div>;
          },
        },
        {
          field: 'status',
          title: this.$translate('Status'),
          key: '2',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return this.$translate(row.status);
          },
        },
        {
          field: 'actions',
          title: '',
          key: '10',
          width: 250,
          renderBodyCell: ({ row }) => {
            return (
              <div class="action-block">
                <div class="copy-button" on-click={() => this.goToDetails(row.id)}>
                  {this.$translate('Details')}
                </div>
                <div class="copy-button" on-click={() => this.pdfButton(row)}>
                  {this.$translate(row.pdf ? 'PDF' : 'Create PDF')}
                </div>
              </div>
            );
          },
        },
      ];
    },
    goToDetails(id) {
      this.$router.push({ name: 'edit-shift-log', params: { id } });
    },
    async pdfButton(row) {
      if (row.pdf) {
        const auth = this.authStorageService.getAuth();
        window.open(`${axios.defaults.baseURL}/api/v1/avg/shift-day/${row.id}/pdf?authorization=${auth.access_token_link}`, '_blank');
      } else {
        this.isCreating = true;
        const responce = await api.shiftDay.createPDF(row.id);
        this.isCreating = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.color-box {
  width: 150px;
  height: 30px;
}

.action-block {
  display: flex;
  justify-content: flex-start;
  width: 235px;
}

::v-deep .copy-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  color: rgb(49, 141, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-right: 20px;
  cursor: pointer;
}
</style>
